import '../styles/page_showcaseJavaScriptComponent.scss';

function PageShowcaseJavaScriptComponent() {

	return (
		<div className="page page_showcaseJavaScriptComponent">
			<h2 className="title">Showcase: JavaScript Component</h2>
			<p className="description">This is a test of a JavaScript component</p>	
			<p>To create a JavaScript component, simply rename the <code>.tsx</code> component to <code>.jsx</code>, and then do a <code>npm start</code> again.</p>
		</div>
	)
}

export default PageShowcaseJavaScriptComponent;